<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Success Metrics
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>How will you measure the success of your advertising campaign?</span>
          </v-tooltip>
        </h1>
        <success-metric
          v-for="(objective, index) in objectives"
          :key="index"
          :objective="objective"
          :selectedObjective="selectedObjective"
          @setObjective="setObjective"
        />
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-btn @click="previousPage">
          Previous
        </v-btn>
        <v-spacer />
        <v-tooltip top v-if="setupMode">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="confirm"
              color="primary"
              :disabled="setupMode"
            >
              Confirm
            </v-btn>
          </template>
          <span>Disabled in setup mode</span>
        </v-tooltip>
        <v-btn
          v-else
          slot="activator"
          @click="confirm"
          color="primary"
          :disabled="setupMode"
        >
          Next
          </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import SuccessMetric from './SuccessMetric'
  export default {
    name: 'success-metrics',
    components: {SuccessMetric},
    data () {
      return {
        next: true,
        objectives: [
          {
            iconOn: 'credit_card',
            title: 'Conversions',
            description: 'Drive the most actions on your site (site views, volunteer or email signups, or donations)',
            value: 'CONVERSIONS',
            label: true
          },
          {
            iconOn: 'person_add',
            title: 'Traffic',
            description: 'Get the most clicks over to your site',
            value: 'LINK_CLICKS'
          },
          {
            iconOn: 'person_add',
            title: 'Post engagement',
            description: 'Get the most likes, shares, or comments on your posts',
            value: 'POST_ENGAGEMENT'
          },
          {
            iconOn: 'person_add',
            title: 'Video views',
            description: 'Get the most video views',
            value: 'VIDEO_VIEWS'
          },
          {
            iconOn: 'record_voice_over',
            title: 'Reach',
            description: 'Get the most people to see your ad (whether they take an action or not)',
            value: 'REACH'
          }
        ],
        selectedObjective: 'CONVERSIONS'
      }
    },
    props: {
      campaign: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      advertisers () {
        return this.$store.getters.getAdvertisers
      },
      user () {
        return this.$store.getters.getCurrentUser
      },
      selectedAdvertiser () {
        return this.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
      },
      setupMode () {
        const setupMode = this.$store.getters.getSetupMode
        return setupMode ? setupMode.status : false
      }
    },
    methods: {
      previousPage () {
        this.$emit('previous')
      },
      confirm () {
        let property = {
          createDate: new Date(),
          status: 'PAUSED',
          objective: this.selectedObjective
        }
        this.$emit('confirm', property)
      },
      setObjective (objective) {
        this.selectedObjective = objective
      }
    }
  }
</script>
